export const reasonToDeclineReferredQuote = ['Underwriting Issues'];

export const reasonsToDeclineAllQuotes = [
  'Class Ineligible',
  'Loss History',
  'Lead Time Insufficient',
  'Capacity',
  'Other',
];

// Applied automatically by the API (LIO-28733) when a lead-capture quote in a jurisdiction the
// offering isn't live in gets auto-declined. Not offered for manual selection here — only added
// to the read-only reason list in DeclinationModal so a previously-stored value renders its label
// instead of a blank Select.
export const systemOnlyDeclineReasons = ['Jurisdiction Not Available'];

export const lossTypes = ['Loss Severity', 'Loss Frequency'];

export const capacityTypes = ['Insufficient Property Limits', 'Insufficient Casualty Limits'];
